import React, { useRef, useEffect,useState } from "react";
import { useSpring, animated } from "react-spring";
import { ReactSortable } from "react-sortablejs";
import { MdClose } from "react-icons/md";
import "./ModalOrderDraft.css";

import OrderDraft from './OrderDraft';
import { orderPlayers } from "../../../../api/handleapi";
import { Errormsg } from "../../../../components/tostifymsg/Errrormsg";
import { Succesmsg } from "../../../../components/tostifymsg/Succesmsg";

export const ModalOrderDraft = ({
  showModalOrderDraft,
  setShowModalOrderDraft,
  leagueId
}) => {
  const [users, setUsers] = useState([]);
  const modalRef = useRef();

  const animation = useSpring({
    config: {
      duration: 350,
    },
    opacity: showModalOrderDraft ? 1 : 0,
    transform: showModalOrderDraft ? `translateY(0%)` : `translateY(-100%)`,
  });

  useEffect(() => {
    const disableScroll = (e) => {
      e.preventDefault();
      window.scroll(0, 0);
    };

    if (showModalOrderDraft) {
      document.body.style.overflow = "hidden";
      window.addEventListener("scroll", disableScroll);
    } else {
      document.body.style.overflow = "auto";
      window.removeEventListener("scroll", disableScroll);
    }

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("scroll", disableScroll);
    };
  }, [showModalOrderDraft]);


  const handlerUsers = async () => {
    const usersReorder = users.map((user, index) => ({
      leagueId: leagueId,
      userId: user.id,
      index: index + 1
    }));

    try {
      const response = await orderPlayers(usersReorder);

      Succesmsg(response?.data?.message ?? 'Order saved successfully');
      setShowModalOrderDraft((prev) => !prev)
    } catch (error) {
      Errormsg(error?.response?.data?.message);
    }
  };

  return (
    <div>
      {showModalOrderDraft && (
        <div ref={modalRef} className="Background_trade">
          <animated.div style={animation}>
            <div className="trading_wrapper ModalWrapper_trade">
              <div className="d-flex w-100">
                
                <h4>Set Draft Order</h4>

                <div
                className="CloseModalButton_trade"
                  aria-label="Close modal"
                  onClick={() => setShowModalOrderDraft((prev) => !prev)}
                >
                  <MdClose className="close_btn"/>
                </div>
              </div>
              <div className="ModalContent_trade">
                <p>
                  Drag and drop players to reorder the draft:
                </p>

                <OrderDraft leagueId={leagueId} handlerUsers={setUsers} />

                <div className="mt-4 d-flex justify-content-center mb-3">
                  <button className="btn btn-danger" onClick={() => setShowModalOrderDraft((prev) => !prev)}>Cancel</button>
                  <button className="btn btn-primary ms-2" onClick={handlerUsers}>Save Order</button>
                </div>
              </div>
            </div>
          </animated.div>
        </div>
      )}
    </div>
  );
}